import React, { useEffect, useRef, useState } from "react";
import "./Summary.css";
import { Popup } from "semantic-ui-react";
import FilterBox from "./Filter_Box/FilterBox";
// import SummaryUpdated from "./SummaryUpdated/SummaryUpdated";
import { useSelector } from "react-redux";
import axios from "../../axios";
import { SubjectIcon } from "../../SubjectIcon";
import moment from "moment";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import SummaryTour from "../../SidebarHeader/Header/SummaryTour";
import { Link, NavLink, useSearchParams } from "react-router-dom";
import SummaryUpdated from "../../DCM/components/SummaryUpdated/SummaryUpdated";
import { BookText, CalendarDays, User } from "lucide-react";
import { shortenParagraph } from "../../utils/Engagement";
// import SummaryNotGenrated from './SummaryUpdated/SummaryNotGenrated';

export default function SummaryMain() {
  const popupRef = useRef(null);
  const [summaryList, setSummaryList] = useState([]);
  const [summaryData, setSummaryData] = useState([])
  // const [summaryID, setSummaryID] = useSearchParams();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const { academic_year, school, section, standard, timetable_session } =
    currentUser;
  const [summaryMain, setSummaryMain] = useState({
    openSummaryDetail: false,
    summaryData: null,
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupSummary");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupSummary", "true");
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".digitalClass",
      intro: `
        <h3>Digital.Class</h3>
        <p>Digital.Class has 2 features (as shown in left most pane):
       </p>
       <ol>
          <li>Summary</li>
          <li>Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneDC",
      intro: `
        <h3>Features Group Left Pane
        Digital.Class has 3 features as shown:</h3>
        <ol>
        <li>Summary</li>
        <li>Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".summary",
      intro: `
        <h3>Summary</h3>
        <p>Currently 'Summary' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".summaryItems",
      intro: `
        <h3>Summary Items</h3>
        <p>These are summary items which you can scroll vertically.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".filterSummary",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject, time and date time.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };

  const togglePopup = () => {
    // setIsPopupOpen(!isPopupOpen)
    setIsPopupOpen((prev) => !prev);
  };

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 20,
    page: 1,
  });
  /// sectionId = 62d98b7c072943b9cff68672
  useEffect(() => {
    const summaryCard = async () => {
      try {
        let response = await axios.get(
          `timetable/getSummaryList/academicYearId/${academic_year?.id}/schoolId/${school?.id}/standardId/${standard?.id}/sectionId/${section?.id}/timetableSessionId/${timetable_session?.id}?` +
          `${filter?.date
            ? `date=${moment(filter?.date).format("YYYY-MM-DD")}&`
            : ``
          }` +
          `${filter?.time ? `time=${filter?.time}&` : ``}` +
          `${filter?.subjectId?.length !== 0
            ? `subjectId=${filter?.subjectId}&`
            : ``
          }`
        );
        response && setSummaryList(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    summaryCard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const CloseSummaryShowToday = () => {
    setSummaryMain({
      ...summaryMain,
      openSummaryDetail: false,
    });
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const timeDateHelper = (a) => {
    const dateObj = new Date(a);

    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = days[dateObj.getDay()];

    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const monthName = months[dateObj.getMonth()];


    const day = dateObj.getDate();
    const getOrdinal = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const ordinal = getOrdinal(day);

    const year = dateObj.getFullYear();

    return `${dayName}, ${day}${ordinal} ${monthName} ${year}`;
  };

  function convertTo12HourFormat(time) {
    const hours = parseInt(time?.substring(0, 2));
    const minutes = time?.substring(2);

    let period = "AM";
    let adjustedHours = hours;

    if (hours >= 12) {
      period = "PM";
      adjustedHours = hours === 12 ? 12 : hours - 12;
    }

    if (adjustedHours === 0) {
      adjustedHours = 12;
    }

    const formattedTime = `${adjustedHours}:${minutes} ${period}`;
    return formattedTime;
  }

  const groupedSummaries = summaryList?.reduce((acc, summary) => {
    const date = summary?.schedule_date;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(summary);
    return acc;
  }, {});

  return (
    <div>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div className="SummaryMainContainer transition-none relative">
        <div className="d-flex" style={{ float: "right", marginLeft: "10px" }}>
          {/* <div className="summaryHeading">Summary</div> */}
          <div>
            <div onClick={togglePopup} className="col-md-12 gap-2 filter_box filterSummary transition-none">
              <img
                className="filter_icon transition-none"
                src="/HwImg/filter Icon.svg"
                alt=""
              />
              <span>Filter</span>
            </div>
            {/* <Popup
              open={isPopupOpen}
              onClose={togglePopup}
              onOpen={togglePopup}
              on="click"
              className="popUpFilter_ass transition-none"
              trigger={
                <div className="col-md-12 gap-2 filter_box filterSummary transition-none">
                  <img
                    className="filter_icon transition-none"
                    src="/HwImg/filter Icon.svg"
                    alt=""
                  />
                  <span>Filter</span>
                </div>
              }
              content={
                
              }
            /> */}
          </div>
        </div>

        <div className="summaryItems orange-scrollBarSummary">
          {summaryList && summaryList.length > 0 ? (
            <div className="pl-4 pt-3">
              {Object.entries(groupedSummaries).map(([date, summaries], index, arr) => (
                <div key={date} className="mb-4">
                  {/* Date Heading */}
                  <h5 className="mb-3 font-semibold text-blue-900">{timeDateHelper(date)}</h5>

                  <div className="d-flex gap-4 flex-wrap">
                    {summaries.map((summary) => (
                      <NavLink
                        key={summary.id}
                        to={`/Summaryupdate`}
                        state={{ SupplementId: summary.id, from: "summary" }}
                      >
                        <div
                          className="w-[360px] h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                          style={{
                            borderTop: `8px solid #${summary?.lecture?.subject?.color}`,
                            position: "relative"
                          }}
                        >
                          <div className="d-flex SubsummarySubBoxContainer justify-content-between">
                            <div>
                              <div className="subboxSubject">
                                {summary?.lecture?.subject?.name}
                              </div>
                              <div className="lessonCount mt-1 flex">
                                <BookText size={16} className="me-2 mt-1 text-dark" />
                                {shortenParagraph(summary?.lecture?.name, 25)}
                              </div>
                              <div className="TeacherName mt-1 flex">
                                <User size={16} className="me-2 text-dark" />
                                {summary?.lecture?.teacher?.name}
                              </div>
                              <div className="flex mt-1">
                                <CalendarDays size={16} className="me-2 text-dark" />
                                <span className="TeacherName">
                                  {timeHelper(summary?.schedule_date)}
                                </span>
                                &nbsp;
                                <span className="timeSummary">
                                  {convertTo12HourFormat(summary?.lecture?.start_time)} -{" "}
                                  {convertTo12HourFormat(summary?.lecture?.end_time)}
                                </span>
                              </div>
                            </div>

                            <div style={{ position: "relative" }}>
                              <img
                                src={`${SubjectIcon?.find(
                                  (i) =>
                                    i.subjectName === summary?.lecture?.subject?.name
                                )?.icon
                                  }`}
                                alt=""
                              />
                              {summary?.attachments?.length > 0 && (
                                <div
                                  style={{ position: "absolute", top: "60px", right: "0px" }}
                                >
                                  <img
                                    src="/images/gallery_img.png"
                                    alt="media_icon"
                                    style={{ width: "40px" }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </NavLink>
                    ))}
                  </div>
                  {index < arr.length - 1 && <hr />}
                </div>
              ))}
            </div>
          ) : isGettingData ? (
            <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
          ) : (
            <span>Summary Not Found</span>
          )}
        </div>
        {/* <SummaryNotGenrated/> */}
        {summaryMain.openSummaryDetail && (
          <SummaryUpdated
            CloseSummaryShowToday={CloseSummaryShowToday}
            summaryData={summaryMain?.summaryData}
          />
        )}
        {homeScreenWalkThroughPopup && (
          <SummaryTour
            setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
            setStepsEnabled={setStepsEnabled}
          />
        )}
        {isPopupOpen && (
          <div ref={popupRef}>
            <FilterBox
              setFilter={setFilter}
              filter={filter}
              togglePopup={togglePopup}
            />
          </div>
        )}
      </div>
    </div >
  );
}
